import { FilterValues } from 'src/model';

export const MinMaxOptionsValues: FilterValues = [
  {
    id: 'Unavailable',
    label: 'Unavailable',
  },
  {
    id: 1,
    label: '1',
  },
  {
    id: 1000000,
    label: '1M',
  },
  {
    id: 10000000,
    label: '10M',
  },
  {
    id: 25000000,
    label: '25M',
  },
  {
    id: 50000000,
    label: '50M',
  },
  {
    id: 100000000,
    label: '100M',
  },
  {
    id: 250000000,
    label: '250M',
  },
  {
    id: 500000000,
    label: '500M',
  },
  {
    id: 1000000000,
    label: '1B',
  },
  {
    id: 10000000000,
    label: '10B',
  },
];

export const EmployeesRangeValues: FilterValues = [
  {
    id: 'Unavailable',
    label: 'Unavailable',
  },
  {
    id: 1,
    label: '1',
  },
  {
    id: 10,
    label: '10',
  },
  {
    id: 50,
    label: '50',
  },
  {
    id: 200,
    label: '200',
  },
  {
    id: 500,
    label: '500',
  },
  {
    id: 1000,
    label: '1000',
  },
  {
    id: 5000,
    label: '5000',
  },
  {
    id: 10000,
    label: '10000',
  },
];

export const NumberOfVisitRangeValues: FilterValues = [
  {
    id: 'Unavailable',
    label: 'Not Visited',
  },
  {
    id: 1,
    label: '1',
  },
  {
    id: 5,
    label: '5',
  },
  {
    id: 10,
    label: '10',
  },
  {
    id: 20,
    label: '20',
  },
  {
    id: 50,
    label: '50',
  },
  {
    id: 100,
    label: '100',
  },
  {
    id: 500,
    label: '500',
  },
  {
    id: 1000,
    label: '1000',
  },
];
